import React, { useState, useEffect } from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = ({ phoneNumber, message }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const openWhatsApp = () => {
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <div className={`whatsapp-button-container ${isVisible ? 'visible' : ''}`}>
      {/* A mensagem do tooltip */}
      <span className="whatsapp-tooltip">Estamos online!</span>

      <button
        className="whatsapp-button"
        onClick={openWhatsApp}
        aria-label="Fale conosco pelo WhatsApp"
      >
        <img src="/images/whatsapp-icon.png" alt="WhatsApp" />
      </button>
    </div>
  );
};

export default WhatsAppButton;